import { gateway } from "../../../../gateway";
import { ICreateInvoicePayload } from "../interfaces/invoice.interfaces";

export const createSystemInvoiceAction = async (
  invoice: ICreateInvoicePayload,
  companyId: number
): Promise<any> => {
  const response = await gateway.post(
    "/invoices/system",
    { ...invoice },
    {
      headers: {
        companyid: companyId.toString(),
      },
    }
  );
  return response.data;
};
